export async function getIsCheckoutComposerEnabled(httpClient) {
  const response = await httpClient.get('/_serverless/checkout-composer-experiment-api/isEnabled');
  return response.data;
}
//# sourceMappingURL=getIsCheckoutExperimentEnabled.js.map